if (typeof CartForm !== "function") {

    class CartForm extends HTMLElement {
        constructor() {
            super();
            this.ajaxifyCartItems();
            this.ajaxifyParticipantDetails();
        }

        ajaxifyParticipantDetails() {
            this.form = this.querySelector("form");

            const validationSchema = Yup.object().shape({
                [encodeURIComponent("attributes[participantFirstName]")]: Yup.string().when(encodeURIComponent("attributes[participantIsNdisParticipant]"), ([participantIsNdisParticipant]) => {
                    if (participantIsNdisParticipant == 'true') {
                        return Yup.string().label('Participant Name').required().typeError('Participant Name is required')
                    }
                    return Yup.string().nullable()
                }),
                [encodeURIComponent("attributes[participantLastName]")]: Yup.string().when(encodeURIComponent('attributes[participantIsNdisParticipant]'), ([participantIsNdisParticipant]) => {
                    if (participantIsNdisParticipant == 'true') {
                        return Yup.string().label('Participant Last Name').required().typeError('Participant Last Name is required')
                    }
                    return Yup.string().nullable()
                }),
                [encodeURIComponent("attributes[participantNdisNumber]")]:
                    Yup.string().when([
                        encodeURIComponent('attributes[participantIsNdisParticipant]'),
                        encodeURIComponent('attributes[participantIsSelfManaged]')
                    ], ([participantIsNdisParticipant, participantIsSelfManaged]) => {
                        if (participantIsNdisParticipant == 'true' && participantIsSelfManaged != 'true') {
                            return Yup.number().label('Participant NDIS Number').required().typeError('Participant NDIS Number is required').min(430000000, 'Participant NDIS Number is invalid').max(599999999, 'Participant NDIS Number is invalid')
                        }
                        return Yup.string().nullable()
                    }),
                [encodeURIComponent("attributes[planManagerEmail]")]:
                    Yup.string().when([
                        encodeURIComponent('attributes[participantIsNdisParticipant]'),
                        encodeURIComponent('attributes[participantIsSelfManaged]')
                    ], ([participantIsNdisParticipant, participantIsSelfManaged]) => {
                        if (participantIsNdisParticipant == 'true' && participantIsSelfManaged != 'true') {
                            return Yup.string().label('Plan Manager Email').email().required('Plan Manager Email is required unless the Participant is Self Managed').typeError()
                        }
                        return Yup.string().nullable()
                    }),
            });

            const transformYupErrorsIntoObject = (errors) => {
                const validationErrors = {}
                if (errors.path !== undefined) {
                    validationErrors[decodeURIComponent(errors.path)] = errors.message;
                }
                errors.inner?.forEach((error) => {
                    if (error.path !== undefined) {
                        validationErrors[decodeURIComponent(error.path)] = error.errors?.[0]
                    }
                })
                return validationErrors
            }

            this.form?.addEventListener("submit", async (e) => {
                this.form.classList.add("processing");
                document.querySelectorAll(".alert").forEach((alert) => {
                    alert.remove();
                });
                try {
                    const formData = new FormData(e.target);
                    const formValues = Object.fromEntries(formData);
                    const safeValues = Object.fromEntries(
                        Object.entries(formValues).map(([key, value]) => {
                            return [encodeURIComponent(key), value]
                        }))
                    await validationSchema.validate(safeValues, {abortEarly: false});
                } catch (err) {
                    const errors = transformYupErrorsIntoObject(err);
                    Object.entries(errors).forEach(([key, value]) => {
                        const selector = `input[name="${key}"]`;
                        const input = document.querySelector(selector);
                        if (input) {
                            const alert = document.createElement("div");
                            alert.classList.add("alert", "alert--error", "w-full", "!mt-1", "!text-red-500");
                            alert.textContent = value;
                            input.after(alert);
                            // scroll to the alert
                            alert.scrollIntoView({behavior: "smooth", block: "center"});
                        }
                    })
                    e.preventDefault();
                    e.target.blur();
                    return false;
                } finally {
                    this.form.classList.remove("processing");
                }
            });

            // get all the participant details custom fields
            // make them save their value on change
            let inputs = this.querySelectorAll('input[name^=attributes]');
            inputs?.forEach((item) => {
                item.addEventListener(
                    "input",
                    debounce(async (e) => {
                        e.preventDefault();
                        const body = new FormData();
                        if (e.target.type === 'checkbox') {
                            body.append(e.target.name, e.target.checked ? 'true' : 'false');
                        } else {
                            body.append(e.target.name, e.target.value);
                        }

                        await fetch(KROWN.settings.routes.cart_url, {
                            method: "POST",
                            body,
                        });
                    }, 500),
                );
            })

            document.getElementById('participantIsNdisParticipant').addEventListener('change', function () {
                if (this.checked) {
                    document.getElementById('participantDetailsFieldset').style.display = 'block';
                } else {
                    document.getElementById('participantDetailsFieldset').style.display = 'none';
                }
            });
            document.getElementById('participantIsSelfManaged').addEventListener('change', function () {
                if (this.checked) {
                    document.getElementById('participantNdisNumber-field').style.display = 'none';
                    document.getElementById('planManagerEmail-field').style.display = 'none';
                } else {
                    document.getElementById('participantNdisNumber-field').style.display = 'block';
                    document.getElementById('planManagerEmail-field').style.display = 'block';
                }
            });
        }

        ajaxifyCartItems() {
            this.form = this.querySelector("form");

            this.querySelectorAll("[data-js-cart-item]").forEach((item) => {
                const remove = item.querySelector(".remove");
                if (remove) {
                    remove.dataset.href = remove.getAttribute("href");
                    remove.setAttribute("href", "");
                    remove.addEventListener("click", (e) => {
                        e.preventDefault();
                        this.updateCartQty(item, 0);
                    });
                }

                const qty = item.querySelector(".qty");
                if (qty) {
                    qty.addEventListener(
                        "input",
                        debounce((e) => {
                            e.preventDefault();
                            e.target.blur();
                            this.updateCartQty(item, parseInt(qty.value));
                        }, 500),
                    );
                    qty.addEventListener("click", (e) => {
                        e.target.select();
                    });
                }
            });
        }

        updateCartQty(item, newQty) {
            let alert = null;

            this.form.classList.add("processing");
            if (this.querySelector(".alert")) {
                this.querySelector(".alert").remove();
            }

            const body = JSON.stringify({
                line: parseInt(item.dataset.line),
                quantity: newQty,
            });

            fetch(KROWN.settings.routes.cart_change_url, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/javascript",
                },
                body,
            })
                .then((response) => response.json())
                .then((response) => {
                    if (response.status == 422) {
                        // wrong stock logic alert
                        alert = document.createElement("span");
                        alert.classList.add("alert", "alert--error");
                        if (typeof response.description === "string") {
                            alert.innerHTML = response.description;
                        } else {
                            alert.innerHTML = response.message;
                        }
                    }
                    return fetch("?section_id=helper-cart");
                })
                .then((response) => response.text())
                .then((text) => {
                    const sectionInnerHTML = new DOMParser().parseFromString(
                        text,
                        "text/html",
                    );
                    const cartFormInnerHTML =
                        sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
                    const cartSubtotalInnerHTML =
                        sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

                    const cartItems = document.getElementById("AjaxCartForm");
                    cartItems.innerHTML = cartFormInnerHTML;
                    cartItems.ajaxifyCartItems();

                    document
                        .querySelectorAll("[data-header-cart-count]")
                        .forEach((elm) => {
                            elm.textContent =
                                cartItems.querySelector("[data-cart-count]").textContent;
                        });
                    document
                        .querySelectorAll("[data-header-cart-total]")
                        .forEach((elm) => {
                            elm.textContent =
                                cartItems.querySelector("[data-cart-total]").textContent;
                        });

                    if (alert !== null) {
                        this.form.prepend(alert);
                    }

                    document.getElementById("AjaxCartSubtotal").innerHTML =
                        cartSubtotalInnerHTML;

                    const event = new Event("cart-updated");
                    this.dispatchEvent(event);
                })
                .catch((e) => {
                    let alert = document.createElement("span");
                    alert.classList.add("alert", "alert--error");
                    alert.textContent = KROWN.settings.locales.cart_general_error;
                    this.form.prepend(alert);
                })
                .finally(() => {
                    this.form.classList.remove("processing");
                    this.ajaxifyParticipantDetails();
                });
        }
    }

    if (typeof customElements.get("cart-form") == "undefined") {
        customElements.define("cart-form", CartForm);
    }
}

if (typeof CartProductQuantity !== "function") {
    class CartProductQuantity extends HTMLElement {
        constructor() {
            super();
            this.querySelector(".qty-minus").addEventListener(
                "click",
                this.changeCartInput.bind(this),
            );
            this.querySelector(".qty-plus").addEventListener(
                "click",
                this.changeCartInput.bind(this),
            );
        }

        changeCartInput() {
            setTimeout(() => {
                document
                    .getElementById("AjaxCartForm")
                    .updateCartQty(
                        this.closest("[data-js-cart-item]"),
                        parseInt(this.querySelector(".qty").value),
                    );
            }, 50);
        }
    }

    if (typeof customElements.get("cart-product-quantity") == "undefined") {
        customElements.define("cart-product-quantity", CartProductQuantity);
    }
}

// method for apps to tap into and refresh the cart

if (!window.refreshCart) {
    window.refreshCart = () => {
        fetch("?section_id=helper-cart")
            .then((response) => response.text())
            .then((text) => {
                const sectionInnerHTML = new DOMParser().parseFromString(
                    text,
                    "text/html",
                );
                const cartFormInnerHTML =
                    sectionInnerHTML.getElementById("AjaxCartForm").innerHTML;
                const cartSubtotalInnerHTML =
                    sectionInnerHTML.getElementById("AjaxCartSubtotal").innerHTML;

                const cartItems = document.getElementById("AjaxCartForm");
                cartItems.innerHTML = cartFormInnerHTML;
                cartItems.ajaxifyCartItems();

                document.querySelectorAll("[data-header-cart-count]").forEach((elm) => {
                    elm.textContent =
                        cartItems.querySelector("[data-cart-count]").textContent;
                });
                document.querySelectorAll("[data-header-cart-total]").forEach((elm) => {
                    elm.textContent =
                        cartItems.querySelector("[data-cart-total]").textContent;
                });

                document.getElementById("AjaxCartSubtotal").innerHTML =
                    cartSubtotalInnerHTML;
                if (document.querySelector("[data-js-site-cart-sidebar]")) {
                    document.querySelector("[data-js-site-cart-sidebar]").show();
                }

                if (document.querySelector("cart-recommendations")) {
                    document.querySelector("cart-recommendations").innerHTML = "";
                    document
                        .querySelector("cart-recommendations")
                        .generateRecommendations();
                }
            });
    };
}
